import React, { Component } from 'react';
import {Rect} from 'react-konva';
import Konva from 'konva';


class ColoredRect extends Component {
  state = {
    color: 'green'
  };
  handleClick = () => {
    this.setState({
      color: Konva.Util.getRandomColor()
    });
  };
  render() {
    return (
      <Rect
        x={20}
        y={20}
        width={100}
        height={50}
        fill={this.state.color}
        shadowBlur={5}
        onClick={this.handleClick}
      />
    );
  }
}
export default ColoredRect;



// WEBPACK FOOTER //
// ./src/Content/Pages/Animation/Animation.js